function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.6714,
  cy: 22,
  r: 8,
  stroke: "#009473",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8211 21.0981C11.123 19.8178 6.59337 24.3395 4.82071 26.9499C3.04804 29.5602 0.475115 35.4042 3.32502 39.6149C6.17493 43.8256 18.7111 45.7298 23.7749 41.8229C28.8386 37.916 26.056 31.3642 20.2741 30.7237C14.4922 30.0833 19.4436 22.6985 14.8211 21.0981Z",
  stroke: "#009473",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.67139,
  y: 1,
  width: 13,
  height: 14,
  stroke: "#009473",
  strokeWidth: 2
});

var SvgS11SampleIcon = function SvgS11SampleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgS11SampleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/s1-1-sample-icon.4d020808.svg";
export { ForwardRef as ReactComponent };